import { Observable } from 'rxjs';
import { IMenuFilter } from '@nimbus-library/features/menu';

export class RequestFilter implements IMenuFilter {
  public constructor(private readonly isDisplayed$: Observable<boolean>) {}

  public validate$(): Observable<boolean> {
    return this.isDisplayed$;
  }
}
